import { StringType } from '@hb/map-convert';
import { convertBooleanToString, convertKeywords } from '../../utils/transform';
/**
 * 入参转换
 */
export var queryType = {
    keywords: StringType(convertKeywords),
    types: StringType(convertKeywords),
    city: StringType(),
    citylimit: StringType(convertBooleanToString),
    children: StringType(),
    offset: StringType(),
    page: StringType(),
    extensions: StringType(),
    special: StringType(),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2FtYXAvcG9pU2VhcmNoL2NvbnZlcnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRzdDLE9BQU8sRUFBRSxzQkFBc0IsRUFBRSxlQUFlLEVBQUUsTUFBTSx1QkFBdUIsQ0FBQztBQUVoRjs7R0FFRztBQUNILE1BQU0sQ0FBQyxJQUFNLFNBQVMsR0FBZ0I7SUFDcEMsUUFBUSxFQUFFLFVBQVUsQ0FBQyxlQUFlLENBQUM7SUFDckMsS0FBSyxFQUFFLFVBQVUsQ0FBQyxlQUFlLENBQUM7SUFDbEMsSUFBSSxFQUFFLFVBQVUsRUFBRTtJQUNsQixTQUFTLEVBQUUsVUFBVSxDQUFDLHNCQUFzQixDQUFDO0lBQzdDLFFBQVEsRUFBRSxVQUFVLEVBQUU7SUFDdEIsTUFBTSxFQUFFLFVBQVUsRUFBRTtJQUNwQixJQUFJLEVBQUUsVUFBVSxFQUFFO0lBQ2xCLFVBQVUsRUFBRSxVQUFVLEVBQUU7SUFDeEIsT0FBTyxFQUFFLFVBQVUsRUFBRTtDQUN0QixDQUFDIn0=